export class Supplier {
  companyName = "";
  isBusinessPartner = false;
  email = "";
}
